/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { DynamicFormLayoutService } from '../../../service/dynamic-form-layout.service'
import { DynamicFormValidationService } from '../../../service/dynamic-form-validation.service'
import { BaseFormControlComponent } from '../base-form-control.component'

@Component({
  selector: 'dynamic-basic-paragraph',
  templateUrl: './dynamic-basic-paragraph.component.html',
  styles: [':host { display: block;}', ':host ::ng-deep a { text-decoration: underline; }'],
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DynamicBasicParagraphComponent extends BaseFormControlComponent {
  // @ts-ignore
  layoutService: DynamicFormLayoutService
  // @ts-ignore
  validationService: DynamicFormValidationService

  constructor() {
    const layoutService = inject(DynamicFormLayoutService)
    const validationService = inject(DynamicFormValidationService)

    super()

    this.layoutService = layoutService
    this.validationService = validationService
  }
}
